var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-menu',{staticClass:"is-custom-mobile MenuRecursive"},[_c('MenuRecursiveHelper',{attrs:{"items":_vm.items,"value":String(_vm.value),"allLevelsConfig":_vm.allLevelsConfig,"currentNestingDepth":0},on:{"input":_vm.input}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }